import React, { useState } from "react";

import { BaseDropdown } from "@components/library/UI/BaseDropdown";

import { ReactComponent as ArrowIcon } from "@assets/images/icons/arrow-down-icon.svg";
import { ReactComponent as InfinityIcon } from "@assets/images/icons/infinity-icon.svg";

import "./PerformanceStats.sass";

export const PerformanceStats = () => {
  const [period, setPeriod] = useState("30 Days");

  const win = 169;
  const lose = 0;
  const totalGames = win + lose;
  const winPercentage = totalGames === 0 ? 0 : (win / totalGames) * 100;

  const listStats = [
    { label: "Profit-to-Loss Ratio", value: "1.85 : 0" },
    { label: "Weekly Trades", value: "169.17" },
    { label: "Avg. Holding Time", value: "45Mins" },
    { label: "POI Volatility", value: "6.12%" },
    { label: "Sharpe Ratio", value: "2.50" },
    { label: "Sortino Ratio", value: <InfinityIcon /> },
    { label: "Last Traded at", value: "2026-01-23, 13:11:02" },
  ];

  return (
    <div className="performance-stats">
      {/* HEADER */}
      <div className="performance-stats__header">
        <h2 className="performance-stats__title">Performance</h2>
        <BaseDropdown
          trigger={
            <button className="performance-stats__dropdown-btn">
              {period} <ArrowIcon />
            </button>
          }
        >
          {({ closeDropdown }) => (
            <div className="performance-stats__dropdown-menu">
              {["7 Days", "30 Days", "90 Days"].map((opt) => (
                <div
                  key={opt}
                  className="performance-stats__dropdown-item"
                  onClick={() => {
                    setPeriod(opt);
                    closeDropdown();
                  }}
                >
                  {opt}
                </div>
              ))}
            </div>
          )}
        </BaseDropdown>
      </div>

      {/* TOP ROI/PNL GRID */}
      <div className="performance-stats__roi-grid">
        <div className="performance-stats__roi-col">
          <p className="performance-stats__label">Total ROI</p>
          <p className="performance-stats__value performance-stats__value--green">
            +13.84%
          </p>
        </div>
        <div className="performance-stats__roi-col performance-stats__roi-col--right">
          <p className="performance-stats__label">Total PNL</p>
          <p className="performance-stats__value performance-stats__value--green">
            +$267,253.09
          </p>
        </div>

        <div className="performance-stats__roi-col">
          <p className="performance-stats__label">Total ROI</p>
          <p className="performance-stats__value">100.00%</p>
        </div>
        <div className="performance-stats__roi-col performance-stats__roi-col--right">
          <p className="performance-stats__label">Total PNL</p>
          <p className="performance-stats__value performance-stats__value--white">
            +$2,053.33
          </p>
        </div>

        <div className="performance-stats__roi-col">
          <p className="performance-stats__label">Total ROI</p>
          <p className="performance-stats__value">0.00%</p>
        </div>
        <div className="performance-stats__roi-col performance-stats__roi-col--right">
          <p className="performance-stats__label">Total PNL</p>
          <p className="performance-stats__value performance-stats__value--green">
            +$1.89
          </p>
        </div>
      </div>

      {/* WIN / LOSE BAR */}
      <div className="performance-stats__win-loss">
        <div className="performance-stats__win-loss-text">
          <span className="performance-stats__win">Win {win}</span>
          <span className="performance-stats__lose">Lose {lose}</span>
        </div>
        <div className="performance-stats__win-loss-track">
          <div
            className="performance-stats__win-loss-fill"
            style={{ width: `${winPercentage}%` }}
          ></div>
        </div>
      </div>

      {/* LIST METRICS */}
      <div className="performance-stats__list">
        {listStats.map((stat, i) => (
          <div className="performance-stats__list-item" key={i}>
            <span className="performance-stats__list-label">{stat.label}</span>
            <span className="performance-stats__list-value">{stat.value}</span>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="performance-stats__footer">Measured in: USDT</div>
    </div>
  );
};
